<div id="message" class="py-4 mx-md-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="home-title text-center mb-2">Messages From Leadership</h2>
            </div>
        </div>

        <owl-carousel-o [options]="customOptions">
            <ng-container>

                <ng-template carouselSlide>
                    <div class="row">
                        <div class="col-12">
                            <div class="message-card">
                                <div class="row g-0">
                                    <!-- Left Column: Image with Overlay -->
                                    <div class="col-12 col-md-5 message-image-wrapper">
                                        <img src="/assets/img/messages/Principal.JPG" class="message-image"
                                            alt="Principal Message"
                                            onerror="this.src='https://placehold.co/400x500?text=Principal'">
                                        <div class="image-overlay">
                                            <h3 class="overlay-name">Smt. Shalini Rana</h3>
                                            <p class="overlay-title">Principal, Aryakulam International School</p>
                                        </div>
                                    </div>

                                    <!-- Right Column: Message Content -->
                                    <div class="col-12 col-md-7 message-content-wrapper">
                                        <div class="message-content">
                                            <div class="quote-icon">
                                                <i class="fas fa-quote-right"></i>
                                            </div>
                                            <h2 class="message-heading">A Message from Our Principal</h2>
                                            <div class="message-text">
                                                <p class="message-quote">"Knowledge is the Supreme Strength"</p>
                                                <p class="message-description">At ARYAKULAM International School, we
                                                    steadfastly uphold our guiding motto, <strong>“ज्ञानम् परम् बलम्” —
                                                        Knowledge is the Supreme Strength</strong>, as the cornerstone
                                                    of our educational philosophy. Education is a transformative journey
                                                    that refines intellect and strengthens character.
                                                </p>
                                            </div>
                                            <button class="read-more-btn" routerLink="/about/principal">
                                                Read Full Message
                                                <i class="fas fa-arrow-right ms-2"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template carouselSlide>
                    <div class="row">
                        <div class="col-12">
                            <div class="message-card">
                                <div class="row g-0">
                                    <!-- Left Column: Image with Overlay -->
                                    <div class="col-12 col-md-5 message-image-wrapper">
                                        <img src="/assets/img/messages/Chairman.JPG" class="message-image"
                                            alt="Chairman Message"
                                            onerror="this.src='https://placehold.co/400x500?text=Chairman'">
                                        <div class="image-overlay">
                                            <h3 class="overlay-name">Sh. Mahipal Singh</h3>
                                            <p class="overlay-title">Chairman, Aryakulam International School</p>
                                        </div>
                                    </div>

                                    <!-- Right Column: Message Content -->
                                    <div class="col-12 col-md-7 message-content-wrapper">
                                        <div class="message-content">
                                            <div class="quote-icon">
                                                <i class="fas fa-quote-right"></i>
                                            </div>
                                            <h2 class="message-heading">A Message from Our Chairman</h2>
                                            <div class="message-text">
                                                <p class="message-quote">"ज्ञानम् परम् बलम्"</p>
                                                <p class="message-description hindi-text">श्री रहतु राम मेमोरियल सभा के
                                                    पावन संरक्षण में आर्यकुलम् इंटरनेशनल स्कूल की आधारशिला एक दृढ़
                                                    संकल्प के साथ रखी गई थी—कि शिक्षा मात्र जीविकोपार्जन का साधन नहीं,
                                                    अपितु राष्ट्र-निर्माण का सबसे सशक्त और स्थायी अधिष्ठान है।</p>
                                            </div>
                                            <button class="read-more-btn" routerLink="/about/chairperson">
                                                Read Full Message
                                                <i class="fas fa-arrow-right ms-2"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o>

    </div>
</div>